import * as React from 'react';

import { BottomNavigation, BottomNavigationProps } from '../BottomNavigation';
import { QuestionPalletes } from '../QuestionPalletes';
import bookCover from './book-covers/reading-book-cover.png';

interface ReadingBottomNavigationProps extends BottomNavigationProps {}

export const ReadingBottomNavigation = (props: ReadingBottomNavigationProps) => (
  <BottomNavigation defaultBookCover={bookCover} {...props}>
    <QuestionPalletes />
  </BottomNavigation>
);
